
const checkoutBtns = document.querySelectorAll('.horizontal-offer-badge, .cta-button, .circle-badge')

checkoutBtns.forEach(el => {
  el.addEventListener('click', function () {
    const variId = this.getAttribute('variant-id')
    if(variId){
      console.log("variId", variId)
      this.classList.add('disabled', 'shimmer')
      // Add item to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status && data.status === 422) {
          throw new Error(data.description || 'Product could not be added to cart');
        }
        
        // Redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
        alert('There was an error processing your request. Please try again.');
        this.classList.remove('disabled', 'shimmer')
      });
    }
  })
})